import { useEffect, useState } from 'react'
import Card from '@mui/material/Card'
import MeService from '../../services/me-service.js'

const Unsubscribe = () => {
  const [email, setEmail] = useState(null)

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const email = queryParams.get('email')
    MeService.unsubscribe({
      email,
    }).then(res => {
      setEmail(res.email)
    })
  }, [])

  return (
    <Card className="p-5 bg-transparent shadow-none">
      <div className="w-full text-center p-12">
        {email === null ? (
          <h1>Loading...</h1>
        ) : (
          <h1>
            Te-ai dezabonat cu succes de la {process.env.REACT_APP_NAME} pe
            adresa {email}!
          </h1>
        )}
      </div>
    </Card>
  )
}

export default Unsubscribe
